import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { TextBox } from "../core/components/textBox";
import { IndividualField, SelectionType } from "./editField";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react"
export default class EditDatatype extends React.Component<EditDatatypeProps, EditDatatypeState> {
    private factory = ComponentHelper.createFactory();
    private dataTypeStructure: TextValue[] = null;
    private categories: { text: string, value: number, usableForDataTables: boolean }[];
    private translations: StringKeyDictionary<string>;
    private baseValue: string;
    private sheet: Sheet;
    private lock: boolean;
    constructor(props: EditDatatypeProps) {
        super(props);
        this.translations = null;
        this.baseValue = props.value;
        this.state = {
            value: props.value,
            category: 0,
            dataTableActive: props.entity.SelectionType == SelectionType.ComboBox || props.entity.SelectionType == SelectionType.DropDownList || props.entity.SelectionType == SelectionType.MultiLangDropDownList,
            waitForLookUp: false
        }
        this.initApp();
    }

    private initApp = async () => {
        const result = await Helper.getTranslations(["WebCRM.EditIndividualFields.DataType.All",
            "WebCRM.EditIndividualFields.DataType.UnicodeString",
            "WebCRM.EditIndividualFields.DataType.NumericValues",
            "WebCRM.EditIndividualFields.DataType.DateAndTime",
            "WebCRM.EditIndividualFields.DataType.Other",
            "WebCRM.EditIndividualFields.DataType.String",
            "WebCRM.EditIndividualCategories.DataTypeDependsOnLookUp"
        ]);
        this.translations = result.Data;
        this.setCategories();
        this.lock = false;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.setEvents();
        this.setState({})
    }

    private setEvents = () => {
        this.sheet.bind(SheetEventType.Custom, this.handleLock)
    }

    private handleLock = (data) => {
        const cmd = Helper.getAttributeSavely(data, "cmd");
        switch (cmd) {
            case "lockDataType":
                this.lock = true;                
                this.setState({ waitForLookUp: false }, () => {
                    this.updateValue(data.dataType);
                });
                break;
            case "unlockDataType":
                this.lock = false;
                this.setState({ waitForLookUp: false }, () => {
                    this.updateValue(this.baseValue);
                });
                break;
            case "waitForLookUp":
                this.setState({ waitForLookUp: true });
                break;
        }
    }


    private updateValue = (value: string) => {
        if (this.state.value !== value)
            this.setState({ value: value}, () => { this.props.onChange(this.props.field, value) });
    }

    private setCategories = () => {        
        this.dataTypeStructure = [
            {
                text: this.translations["WebCRM.EditIndividualFields.DataType.All"],
                value: 0,
                usableForDataTables: true
            },
            {
                text: this.translations["WebCRM.EditIndividualFields.DataType.NumericValues"],
                value: 1,
                usableForDataTables: true,
                data: [
                    {
                        text: "int",
                        value: "int",
                        usableForDataTables: true
                    },
                    {
                        text: "decimal",                       
                        value: "decimal",
                        usableForDataTables: false
                    },
                    {
                        text: "bigint",
                        value: "bigint",
                        usableForDataTables: true
                    },
                    {
                        text: "smallint",
                        value: "smallint",
                        usableForDataTables: true
                    },
                    {
                        text: "bit",
                        value: "bit",
                        usableForDataTables: false
                    },
                    {
                        text: "float",
                        value: "float",
                        usableForDataTables: false
                    }
                ]
            },
            {
                text: this.translations["WebCRM.EditIndividualFields.DataType.DateAndTime"],
                value: 2,
                usableForDataTables: false,
                data: [
                    {
                        text: "date",
                        value: "date",
                        usableForDataTables: false
                    },
                    {
                        text: "datetime",
                        value: "datetime",
                        usableForDataTables: false
                    },
                    {
                        text: "time",
                        value: "time",
                        usableForDataTables: false
                    }
                ]
            },
            {
                text: this.translations["WebCRM.EditIndividualFields.DataType.String"],
                value: 3,
                usableForDataTables: true,
                data: [
                    {
                        text: "char",
                        value: "char",
                        usableForDataTables: true
                    },
                    {
                        text: "varchar",
                        value: "varchar",
                        usableForDataTables: true
                    }
                    //{
                    //    text: "text",
                    //    value: "text",
                    //    usableForDataTables: false
                    //}
                ]
            },
            {
                text: this.translations["WebCRM.EditIndividualFields.DataType.UnicodeString"],
                usableForDataTables: true,
                value: 4,
                data: [
                    {
                        text: "nchar",
                        value: "nchar",
                        usableForDataTables: true
                    },
                    {
                        text: "nvarchar",
                        value: "nvarchar",
                        usableForDataTables: true
                    },
                    //{
                    //    text: "ntext",
                    //    value: "ntext",
                    //    usableForDataTables: false
                    //}
                ]
            }
        ];
        if (this.props.context.isUniCode && this.props.entity.IsNew)
            this.dataTypeStructure = this.dataTypeStructure.filter(dts => dts.value != 3)
        this.categories = this.dataTypeStructure.map((item) => {
            return {
                text: item.text,
                value: item.value,
                usableForDataTables: item.usableForDataTables
            };
        });
    }

    private createCategoryDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.categories
        if (this.state.dataTableActive) {
            props.dataSource = this.categories.filter(f => f.usableForDataTables);
        }
        props.field.dataTextField = "text";
        props.field.dataValueField = "value";
        props.field.optionLabel = "";
        props.field.refreshDSOnRefChange = true;
        props.value = this.state.category;
        props.onChange = (_, value) => {
            this.setState({ category: value })
            this.updateValue("");
        }
        return (
            <div style={{ width: "48.5%", marginRight: "10px" }}>
                <DropDownList {...props}/>
            </div>
            );
    }

    private createValueDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        let dataSource: any
        if (!this.props.entity.IsNew) {
            let category = -1;
            for (let i = 1; i < this.dataTypeStructure.length; i++) {
                let index = this.dataTypeStructure[i].data.findIndex(f => f.value === this.baseValue);
                if (index > -1) {
                    category = this.dataTypeStructure[i].value;
                    break;
                }
            }
            switch (category) {
                case 1:
                case 2:
                case 5:
                    props.dataSource = this.dataTypeStructure[category];
                    break;
                case 3:
                case 4:
                    let values = [];
                    for (let i = 0; i < this.dataTypeStructure[3].data.length; i++) {
                        values.push(this.dataTypeStructure[3].data[i]);
                    }
                    for (let i = 0; i < this.dataTypeStructure[4].data.length; i++) {
                        values.push(this.dataTypeStructure[4].data[i]);
                    }
                    props.dataSource = values;
                    break;
                default:
                    props.dataSource = this.loadDataTypes();
                    break;
            }
        } else if (this.state.category === 0) {
            props.dataSource = this.loadDataTypes();
        } else {
            dataSource = this.dataTypeStructure.find(f => f.value === this.state.category);
            if (Helper.hasValue(dataSource)) {
                props.dataSource = dataSource.data.map((item) => {
                    return {
                        text: item.text,
                        value: item.value,
                        usableForDataTables: item.usableForDataTables
                    };
                });
            }
        }
        //if (this.state.dataTableActive) {
        //    props.dataSource = this.props.entity.IsNew ? props.dataSource.filter(f => f.usableForDataTables) : props.dataSource.data.filter(f => f.usableForDataTables)
        //}
        props.field.dataTextField = "text";
        props.field.dataValueField = "value";
        props.value = this.state.value;
        props.onChange = (_, value) => {
            this.updateValue(value);
            this.setState({value: value})
        }
        props.disabled = this.props.disabled;
        props.field.refreshDSOnRefChange = true;
        let style: React.CSSProperties = {};
        if (this.props.entity.IsNew) {
            style = {
                width: "48.5%"
            }
        } else {
            style = {
                width: "100%"
            }
        }
        return (
            <div style={style}>
                <DropDownList {...props} />
            </div>
        );
    }

    private createTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.disabled = true;
        props.value = this.state.value;
        return (
            <div style={{ width: "100%" }}>
                <TextBox {...props} />
            </div>
        );
    }

    private loadDataTypes = () => {
        let values = [];
        for (let i = 1; i < this.dataTypeStructure.length; i++) {
            for (let j = 0; j < this.dataTypeStructure[i].data.length; j++) {
                values.push(this.dataTypeStructure[i].data[j]);
            }
        }
        return values;
    }

    componentDidUpdate() {
        const dataTableActive = this.props.entity.SelectionType == SelectionType.ComboBox || this.props.entity.SelectionType == SelectionType.DropDownList || this.props.entity.SelectionType == SelectionType.MultiLangDropDownList;
        if (dataTableActive != this.state.dataTableActive) {
            this.setState({ dataTableActive: dataTableActive });
        }
    }

    componentWillUnmount() {
        this.sheet.unbind(SheetEventType.Custom, this.handleLock)
    }

    render() {
        if (Helper.hasValue(this.translations)) {
            if (this.state.waitForLookUp) {
                return (
                    <div>
                        <label>
                            {this.translations["WebCRM.EditIndividualCategories.DataTypeDependsOnLookUp"]}
                        </label>
                    </div>
                );
            } else {
                return (
                    <div style={{ display: "flex", alignItems: "baseline" }}>
                        {(this.props.entity.IsNew && !this.lock) ? this.createCategoryDropDown() : null}
                        {this.lock ? this.createTextBox() : this.createValueDropDown()}
                    </div>
                );
            }
            
        } else {
            return null;
        }
    }
}

interface EditDatatypeProps {
    value: string;
    field: any;
    onChange: (field, value) => void;
    disabled: boolean;
    entity: IndividualField;
    context: {
        isUniCode: boolean
    }
}

interface TextValue {
    text: string;
    value: any;
    usableForDataTables: boolean;
    data?: TextValue[]
}

interface EditDatatypeState {
    category: number;
    value: string;
    dataTableActive: boolean;
    waitForLookUp: boolean;
}
